<template>
    <v-card style="height: 100%; max-height: 100%; overflow-y: scroll;" class="ma-0 pa-0" flat>
      <v-row class="ma-0 pa-0" style="width: 100%;">
        <v-col :cols="spend_impr_contribution_col_size" class="ma-0 pa-0" style="height: calc(100% - 10px);">
          <v-row class="ma-0 pa-0" justify="space-around">
            <v-col cols="12" class="ma-0 pa-0 py-3">
              <v-row class="ma-0 pa-0">
                <v-spacer></v-spacer>
                <v-col cols="12" class="ma-0 pa-0">
                  <v-row class="ma-0 pa-0">
                    <v-col class="ma-0 pa-0" cols="7" style="display: flex; justify-content: center">
                      <span class="compMainStat">{{ format_spend(graph_data['spend']) }}</span>
                    </v-col>
                    <v-col cols="auto" class="ma-0 pa-0 pl-1" style="display: flex; justify-content: center; align-items: center;">
                      <span class="compPercentage" v-if="graph_data['spend_change'] === '-' || graph_data['spend_change'] == 0">{{ format_percentage(graph_data['spend_change']) }}</span>
                      <span class="compPercentage" style="color: red" v-else-if="graph_data['spend_change'] < 0">{{ format_percentage(graph_data['spend_change']) }}</span>
                      <span class="compPercentage" style="color: green" v-else>{{ format_percentage(graph_data['spend_change']) }}</span>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col class="ma-0 pa-0" cols="7" style="display: flex; justify-content: center">
                  <span class="compMainTitle">Spend</span>
                </v-col>
                <v-spacer></v-spacer>
              </v-row>
            </v-col>
            <v-col cols="12" class="ma-0 pa-0 py-3">
              <v-row class="ma-0 pa-0">
                <v-spacer></v-spacer>
                <v-col cols="12" class="ma-0 pa-0">
                  <v-row class="ma-0 pa-0">
                    <v-col class="ma-0 pa-0" cols="7" style="display: flex; justify-content: center">
                      <span class="compMainStat">{{ format_roas(graph_data['roas']) }}</span>
                    </v-col>
                    <v-col cols="auto" class="ma-0 pa-0 pl-1" style="display: flex; justify-content: center; align-items: center;">
                      <span class="compPercentage" v-if="graph_data['roas_change'] === '-' || graph_data['roas_change'] == 0">{{ format_percentage(graph_data['roas_change']) }}</span>
                      <span class="compPercentage" style="color: red" v-else-if="graph_data['roas_change'] < 0">{{ format_percentage(graph_data['roas_change']) }}</span>
                      <span class="compPercentage" style="color: green" v-else>{{ format_percentage(graph_data['roas_change']) }}</span>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col class="ma-0 pa-0" cols="7" style="display: flex; justify-content: center">
                  <span class="compMainTitle">ROAS</span>
                </v-col>
                <v-spacer></v-spacer>
              </v-row>
            </v-col>
            <v-col cols="12" class="ma-0 pa-0 py-3">
              <v-row class="ma-0 pa-0">
                <v-spacer></v-spacer>
                <v-col cols="12" class="ma-0 pa-0">
                  <v-row class="ma-0 pa-0">
                    <v-col class="ma-0 pa-0" cols="7" style="display: flex; justify-content: center">
                      <span class="compMainStat">{{ format_spend(graph_data['volume']) }}</span>
                    </v-col>
                    <v-col cols="auto" class="ma-0 pa-0 pl-1" style="display: flex; justify-content: center; align-items: center;">
                      <span class="compPercentage" v-if="graph_data['volume_change'] === '-' || graph_data['volume_change'] == 0">{{ format_percentage(graph_data['volume_change']) }}</span>
                      <span class="compPercentage" style="color: red" v-else-if="graph_data['volume_change'] < 0">{{ format_percentage(graph_data['volume_change']) }}</span>
                      <span class="compPercentage" style="color: green; margin-left:2px;" v-else>{{ format_percentage(graph_data['volume_change']) }}</span>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col class="ma-0 pa-0" cols="7" style="display: flex; justify-content: center">
                  <span class="compMainTitle">Vol.</span>
                </v-col>
                <v-spacer></v-spacer>
              </v-row>
            </v-col>
            <!-- <v-col cols="12" class="ma-0 pa-0 py-3">
              <v-row class="ma-0 pa-0">
                <v-spacer></v-spacer>
                <v-col cols="8" class="ma-0 pa-0">
                  <v-row class="ma-0 pa-0">
                    <v-col class="ma-0 pa-0" cols="12" style="display: flex; justify-content: center">
                      <span class="compMainStat">{{ format_spend(0) }}</span>
                    </v-col>
                    <v-col class="ma-0 pa-0" cols="12" style="display: flex; justify-content: center">
                      <span class="compMainTitle">Vol.</span>
                    </v-col>
                  </v-row>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="3" class="ma-0 pa-0 px-0" style="display: flex; justify-content: center; align-items: center;">
                  <span class="compPercentage" v-if="graph_data['volume_change'] === '-' || graph_data['volume_change'] == 0">{{ format_percentage(graph_data['volume_change']) }}</span>
                  <span class="compPercentage" style="color: red" v-else-if="graph_data['volume_change'] < 0">{{ format_percentage(graph_data['volume_change']) }}</span>
                  <span class="compPercentage" style="color: green" v-else>{{ format_percentage(graph_data['volume_change']) }}</span>
                </v-col>
                <v-spacer></v-spacer>
              </v-row>
            </v-col> -->
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </template>
  
  <script>
  
  // Configs
  // import cpalette from "@/configs/ChartColors/get_color_palette.js";
  
  export default {
    name: "PredictionHighlight",
    props: [
      'dataset'
    ],
    components: {
    },
    methods: {
      reload_graph: function () {
        this.graph_visible = false;
        setTimeout(() => (this.graph_visible = true), 10);
      },
      format_percentage: function(stat){
        if(stat == 0 || stat === '-'){
          return "-"
        }
        return (stat * 100).toLocaleString("en-CA",{minimumFractionDigits: 1, maximumFractionDigits: 1, notation: 'compact'}) + "%"
      },
      format_spend: function(stat){
        if(stat == 0 || stat === '-'){
          return "-"
        }
        return stat.toLocaleString("en-CA",{style: "currency", currency: "CAD",  minimumFractionDigits: 1, maximumFractionDigits: 1, notation: 'compact'})
      },
      format_roas: function(stat){
        if(stat == 0 || stat === '-'){
          return "-"
        }
        return stat.toLocaleString("en-CA",{style: "currency", currency: "CAD",  minimumFractionDigits: 2, maximumFractionDigits: 2, notation: 'compact'})
      },
    },
  
    data: () => ({
      graph_visible: false,

      graph_data: {
        'spend_change': 0,
        'roas_change': 0,
        'volume_change': 0
      },

      spend_impr_contribution_overview_comments: false,
      spend_impr_contribution_col_size: 12,
      screenHeight: window.innerHeight * (window.innerHeight > 1000 ? 0.7 : 0.6),
    }),
    mounted() {
      this.graph_data = this.dataset;
      if(this.dataset != null){
        this.reload_graph();
      }
    },
    watch: {
      dataset: {
        immediate: false,
        handler: function () {
          this.graph_data = this.dataset;
          if(this.dataset != null){
            this.reload_graph();
          }
        },
        deep: true,
      }
    },
    computed: {},
  };
  </script>
  
  <style scoped>
  .report-subtitle {
    font-family: "Poppins";
    font-weight: 500;
    font-size: 1.5em;
  }
  .chartAlign {
    margin: auto 0
  }
  .compPercentage{
    font-family: 'Poppins';
    font-weight: 400;
    font-size: 0.7em;
  }
  .compMainTitle{
    font-family: 'Poppins';
    font-weight: 700;
    font-size: 0.7em;
  }
  .compMainStat{
    font-family: 'Poppins';
    font-weight: 400;
    font-size: 1em;
  }
  .compHeader{
    font-family: 'Poppins';
    font-weight: 600;
    font-size: 0.8em;
  }
  .compTitle{
    font-family: 'Poppins';
    font-weight: 600;
  }
  </style>
  